import type { Product } from '../types/index.js';
import { productCategoriesMatch } from '../utils/product-category.js';

export function normalizeSearchQuery(query: string): string {
  return query.trim().toLowerCase();
}

/** Collect searchable text fields for a product (name, SKU, tags, variants, etc.). */
export function getProductSearchFields(product: Product): string[] {
  const variantFields = (product.variants ?? []).flatMap((variant) => [
    variant.name ?? '',
    variant.sku ?? '',
  ]);

  return [
    product.name,
    product.description ?? '',
    product.shortDescription ?? '',
    product.sku ?? '',
    product.slug ?? '',
    product.category ?? '',
    ...(product.tags ?? []),
    ...variantFields,
  ];
}

export function productMatchesSearch(product: Product, rawQuery: string): boolean {
  const query = normalizeSearchQuery(rawQuery);
  if (!query) {
    return true;
  }

  return getProductSearchFields(product).some((field) =>
    field.toLowerCase().includes(query)
  );
}

export function filterProductsBySearch(
  products: Product[],
  rawQuery: string,
  category?: string
): Product[] {
  let results = products;

  if (category) {
    results = results.filter((product) => productCategoriesMatch(product.category, category));
  }

  if (rawQuery.trim()) {
    results = results.filter((product) => productMatchesSearch(product, rawQuery));
  }

  return results;
}
